// extracted by mini-css-extract-plugin
export default {"projects__overview":"projects_projects__overview__qtyc6","projects__cards":"projects_projects__cards__nRT0I","projects__cards_inner":"projects_projects__cards_inner__BlfJc"};